import React from 'react'
import YellowFrame from '../../../assets/early/svg/YellowFrame.svg'
import { ReactComponent as PurpleCheck } from '../../../assets/early/svg/PurpleCheck.svg'
import { useTranslation } from 'react-i18next'
import '../../../styles/early/earlyMotion.css'

function ConfirmFooter({ showConfirm = false, pressConfirm }) {
    const { t } = useTranslation()
    return (
        <div className="">
            <div className="bg-[#FDDF6D] shadow-[inset_0px_4px_4px_0px_#00000040] h-[5px] w-full relative">
                {showConfirm && (
                    <button
                        className="absolute -left-[10px] bg-no-repeat bg-contain flex flex-row items-center justify-center gap-[5px] pl-[15px] pr-[11px] em-confirm em-tap em-tap--card"
                        style={{ backgroundImage: `url(${YellowFrame})`, width: 285, height: 114, top: -57, left: 'calc(50% - 143px)' }}
                        onClick={pressConfirm}
                    >
                        <p className="text-[48px] leading-[62px] font-bold text-[#5E639B]">{t('Confirm')}</p>
                        <PurpleCheck />
                    </button>
                )}
            </div>
            <div className=" w-full h-[90px] bg-[linear-gradient(90.7deg,#212662_-1.66%,rgba(94,99,155,0.74)_107.24%)]"></div>
        </div>
    )
}

export default ConfirmFooter
